/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";
import PartsPartFooter from "../../../blocks/parts/part-footer.tsx";

const manifest = {
  "acf/content-accordion": dynamic(
    () => import("../../../blocks/content/accordion.tsx"),
    "blocks/content/accordion.tsx",
  ),
  "acf/content-accordion-item": dynamic(
    () => import("../../../blocks/content/accordion-item.tsx"),
    "blocks/content/accordion-item.tsx",
  ),
  "acf/content-all-content-items": dynamic(
    () => import("../../../blocks/content/all-content-items.tsx"),
    "blocks/content/all-content-items.tsx",
  ),
  "acf/content-anchor": dynamic(() => import("../../../blocks/content/anchor.tsx"), "blocks/content/anchor.tsx"),
  "acf/content-aside-content": dynamic(
    () => import("../../../blocks/content/aside-content.tsx"),
    "blocks/content/aside-content.tsx",
  ),
  "acf/content-aside-stats": dynamic(
    () => import("../../../blocks/content/aside-stats.tsx"),
    "blocks/content/aside-stats.tsx",
  ),
  "acf/content-aside-stats-item": dynamic(
    () => import("../../../blocks/content/aside-stats-item.tsx"),
    "blocks/content/aside-stats-item.tsx",
  ),
  "acf/content-aside-text": dynamic(
    () => import("../../../blocks/content/aside-text.tsx"),
    "blocks/content/aside-text.tsx",
  ),
  "acf/content-button": dynamic(() => import("../../../blocks/content/button.tsx"), "blocks/content/button.tsx"),
  "acf/content-buttons": dynamic(() => import("../../../blocks/content/buttons.tsx"), "blocks/content/buttons.tsx"),
  "acf/content-case-study-grid": dynamic(
    () => import("../../../blocks/content/case-study-grid.tsx"),
    "blocks/content/case-study-grid.tsx",
  ),
  "acf/content-case-study-list": dynamic(
    () => import("../../../blocks/content/case-study-list.tsx"),
    "blocks/content/case-study-list.tsx",
  ),
  "acf/content-content-grid": dynamic(
    () => import("../../../blocks/content/content-grid.tsx"),
    "blocks/content/content-grid.tsx",
  ),
  "acf/content-content-grid-item": dynamic(
    () => import("../../../blocks/content/content-grid-item.tsx"),
    "blocks/content/content-grid-item.tsx",
  ),
  "acf/content-content-share": dynamic(
    () => import("../../../blocks/content/content-share.tsx"),
    "blocks/content/content-share.tsx",
  ),
  "acf/content-expandable": dynamic(
    () => import("../../../blocks/content/expandable.tsx"),
    "blocks/content/expandable.tsx",
  ),
  "acf/content-form": dynamic(() => import("../../../blocks/content/form.tsx"), "blocks/content/form.tsx"),
  "acf/content-gallery": dynamic(() => import("../../../blocks/content/gallery.tsx"), "blocks/content/gallery.tsx"),
  "acf/content-landing-flowgram": dynamic(
    () => import("../../../blocks/content/landing-flowgram.tsx"),
    "blocks/content/landing-flowgram.tsx",
  ),
  "acf/content-landing-intro-featured": dynamic(
    () => import("../../../blocks/content/landing-intro-featured.tsx"),
    "blocks/content/landing-intro-featured.tsx",
  ),
  "acf/content-logo-carousel": dynamic(
    () => import("../../../blocks/content/logo-carousel.tsx"),
    "blocks/content/logo-carousel.tsx",
  ),
  "acf/content-media": dynamic(() => import("../../../blocks/content/media.tsx"), "blocks/content/media.tsx"),
  "acf/content-media-carousel": dynamic(
    () => import("../../../blocks/content/media-carousel.tsx"),
    "blocks/content/media-carousel.tsx",
  ),
  "acf/content-media-text": dynamic(
    () => import("../../../blocks/content/media-text.tsx"),
    "blocks/content/media-text.tsx",
  ),
  "acf/content-media-text-cta": dynamic(
    () => import("../../../blocks/content/media-text-cta.tsx"),
    "blocks/content/media-text-cta.tsx",
  ),
  "acf/content-page-header-404": dynamic(
    () => import("../../../blocks/content/page-header-404.tsx"),
    "blocks/content/page-header-404.tsx",
  ),
  "acf/content-page-header-article": dynamic(
    () => import("../../../blocks/content/page-header-article.tsx"),
    "blocks/content/page-header-article.tsx",
  ),
  "acf/content-page-header-case-study": dynamic(
    () => import("../../../blocks/content/page-header-case-study.tsx"),
    "blocks/content/page-header-case-study.tsx",
  ),
  "acf/content-page-header-dynamic": dynamic(
    () => import("../../../blocks/content/page-header-dynamic.tsx"),
    "blocks/content/page-header-dynamic.tsx",
  ),
  "acf/content-page-header-marketing": dynamic(
    () => import("../../../blocks/content/page-header-marketing.tsx"),
    "blocks/content/page-header-marketing.tsx",
  ),
  "acf/content-page-header-podcast": dynamic(
    () => import("../../../blocks/content/page-header-podcast.tsx"),
    "blocks/content/page-header-podcast.tsx",
  ),
  "acf/content-page-header-text": dynamic(
    () => import("../../../blocks/content/page-header-text.tsx"),
    "blocks/content/page-header-text.tsx",
  ),
  "acf/content-page-header-whitepaper": dynamic(
    () => import("../../../blocks/content/page-header-whitepaper.tsx"),
    "blocks/content/page-header-whitepaper.tsx",
  ),
  "acf/content-podcast-embed": dynamic(
    () => import("../../../blocks/content/podcast-embed.tsx"),
    "blocks/content/podcast-embed.tsx",
  ),
  "acf/content-quiz": dynamic(() => import("../../../blocks/content/quiz.tsx"), "blocks/content/quiz.tsx"),
  "acf/content-section": dynamic(() => import("../../../blocks/content/section.tsx"), "blocks/content/section.tsx"),
  "acf/content-selected-content": dynamic(
    () => import("../../../blocks/content/selected-content.tsx"),
    "blocks/content/selected-content.tsx",
  ),
  "acf/content-shape-links": dynamic(
    () => import("../../../blocks/content/shape-links.tsx"),
    "blocks/content/shape-links.tsx",
  ),
  "acf/content-site-search": dynamic(
    () => import("../../../blocks/content/site-search.tsx"),
    "blocks/content/site-search.tsx",
  ),
  "acf/content-spacer": dynamic(() => import("../../../blocks/content/spacer.tsx"), "blocks/content/spacer.tsx"),
  "acf/content-sticky-section": dynamic(
    () => import("../../../blocks/content/sticky-section.tsx"),
    "blocks/content/sticky-section.tsx",
  ),
  "acf/content-sticky-sections": dynamic(
    () => import("../../../blocks/content/sticky-sections.tsx"),
    "blocks/content/sticky-sections.tsx",
  ),
  "acf/content-team-grid": dynamic(
    () => import("../../../blocks/content/team-grid.tsx"),
    "blocks/content/team-grid.tsx",
  ),
  "acf/content-team-grid-item": dynamic(
    () => import("../../../blocks/content/team-grid-item.tsx"),
    "blocks/content/team-grid-item.tsx",
  ),
  "acf/content-testimonial": dynamic(
    () => import("../../../blocks/content/testimonial.tsx"),
    "blocks/content/testimonial.tsx",
  ),
  "acf/content-testimonial-callout": dynamic(
    () => import("../../../blocks/content/testimonial-callout.tsx"),
    "blocks/content/testimonial-callout.tsx",
  ),
  "acf/content-text-and-flowgram": dynamic(
    () => import("../../../blocks/content/text-and-flowgram.tsx"),
    "blocks/content/text-and-flowgram.tsx",
  ),
  "acf/content-text-carousel": dynamic(
    () => import("../../../blocks/content/text-carousel.tsx"),
    "blocks/content/text-carousel.tsx",
  ),
  "acf/content-text-carousel-item": dynamic(
    () => import("../../../blocks/content/text-carousel-item.tsx"),
    "blocks/content/text-carousel-item.tsx",
  ),
  "acf/content-text-cta": dynamic(() => import("../../../blocks/content/text-cta.tsx"), "blocks/content/text-cta.tsx"),
  "acf/content-text-media-cluster": dynamic(
    () => import("../../../blocks/content/text-media-cluster.tsx"),
    "blocks/content/text-media-cluster.tsx",
  ),
  "acf/content-three-part": dynamic(
    () => import("../../../blocks/content/three-part.tsx"),
    "blocks/content/three-part.tsx",
  ),
  "acf/content-three-part-item": dynamic(
    () => import("../../../blocks/content/three-part-item.tsx"),
    "blocks/content/three-part-item.tsx",
  ),
  "acf/content-two-column-text": dynamic(
    () => import("../../../blocks/content/two-column-text.tsx"),
    "blocks/content/two-column-text.tsx",
  ),
  "acf/content-two-column-text-item": dynamic(
    () => import("../../../blocks/content/two-column-text-item.tsx"),
    "blocks/content/two-column-text-item.tsx",
  ),
  "acf/homepage-home-intro": dynamic(
    () => import("../../../blocks/homepage/home-intro.tsx"),
    "blocks/homepage/home-intro.tsx",
  ),
  "acf/parts-part-footer": PartsPartFooter,
  "acf/work-page-work-listing": dynamic(
    () => import("../../../blocks/work-page/work-listing.tsx"),
    "blocks/work-page/work-listing.tsx",
  ),
  ...core,
};

const info = {
  "acf/content-accordion": { "slug": "content/accordion", "tags": ["#page"], "flags": {} },
  "acf/content-accordion-item": { "slug": "content/accordion-item", "flags": {} },
  "acf/content-all-content-items": { "slug": "content/all-content-items", "tags": ["#page"], "flags": {} },
  "acf/content-anchor": { "slug": "content/anchor", "tags": ["#page"], "flags": {} },
  "acf/content-aside-content": { "slug": "content/aside-content", "tags": ["#inline"], "flags": {} },
  "acf/content-aside-stats": { "slug": "content/aside-stats", "flags": {} },
  "acf/content-aside-stats-item": { "slug": "content/aside-stats-item", "flags": {} },
  "acf/content-aside-text": { "slug": "content/aside-text", "flags": {} },
  "acf/content-button": { "slug": "content/button", "tags": ["#page"], "flags": {} },
  "acf/content-buttons": { "slug": "content/buttons", "tags": ["#page"], "flags": {} },
  "acf/content-case-study-grid": { "slug": "content/case-study-grid", "tags": ["#page"], "flags": {} },
  "acf/content-case-study-list": { "slug": "content/case-study-list", "tags": ["#page"], "flags": {} },
  "acf/content-content-grid": { "slug": "content/content-grid", "tags": ["#page"], "flags": {} },
  "acf/content-content-grid-item": { "slug": "content/content-grid-item", "flags": {} },
  "acf/content-content-share": { "slug": "content/content-share", "tags": ["#page"], "flags": {} },
  "acf/content-expandable": { "slug": "content/expandable", "tags": ["#page"], "flags": {} },
  "acf/content-form": { "slug": "content/form", "tags": ["#page"], "flags": {} },
  "acf/content-gallery": { "slug": "content/gallery", "tags": ["#page"], "flags": {} },
  "acf/content-landing-flowgram": { "slug": "content/landing-flowgram", "tags": ["#page"], "flags": {} },
  "acf/content-landing-intro-featured": { "slug": "content/landing-intro-featured", "tags": ["#page"], "flags": {} },
  "acf/content-logo-carousel": { "slug": "content/logo-carousel", "tags": ["#page"], "flags": {} },
  "acf/content-media": { "slug": "content/media", "tags": ["#page"], "flags": {} },
  "acf/content-media-carousel": { "slug": "content/media-carousel", "tags": ["#page"], "flags": {} },
  "acf/content-media-text": { "slug": "content/media-text", "tags": ["#page"], "flags": {} },
  "acf/content-media-text-cta": { "slug": "content/media-text-cta", "tags": ["#page"], "flags": {} },
  "acf/content-page-header-404": { "slug": "content/page-header-404", "tags": ["#page"], "flags": {} },
  "acf/content-page-header-article": { "slug": "content/page-header-article", "tags": [], "flags": {} },
  "acf/content-page-header-case-study": { "slug": "content/page-header-case-study", "tags": [], "flags": {} },
  "acf/content-page-header-dynamic": { "slug": "content/page-header-dynamic", "tags": ["#page"], "flags": {} },
  "acf/content-page-header-marketing": { "slug": "content/page-header-marketing", "tags": ["#page"], "flags": {} },
  "acf/content-page-header-podcast": { "slug": "content/page-header-podcast", "tags": [], "flags": {} },
  "acf/content-page-header-text": { "slug": "content/page-header-text", "tags": ["#page"], "flags": {} },
  "acf/content-page-header-whitepaper": { "slug": "content/page-header-whitepaper", "tags": [], "flags": {} },
  "acf/content-podcast-embed": { "slug": "content/podcast-embed", "tags": ["#page"], "flags": {} },
  "acf/content-quiz": { "slug": "content/quiz", "tags": ["#page"], "flags": {} },
  "acf/content-section": { "slug": "content/section", "flags": {} },
  "acf/content-selected-content": { "slug": "content/selected-content", "tags": ["#page"], "flags": {} },
  "acf/content-shape-links": { "slug": "content/shape-links", "tags": ["#page"], "flags": {} },
  "acf/content-site-search": { "slug": "content/site-search", "tags": ["#search"], "flags": {} },
  "acf/content-spacer": { "slug": "content/spacer", "tags": ["#page"], "flags": {} },
  "acf/content-sticky-section": { "slug": "content/sticky-section", "tags": ["#page"], "flags": {} },
  "acf/content-sticky-sections": { "slug": "content/sticky-sections", "tags": ["#page"], "flags": {} },
  "acf/content-team-grid": { "slug": "content/team-grid", "tags": ["#page"], "flags": {} },
  "acf/content-team-grid-item": { "slug": "content/team-grid-item", "flags": {} },
  "acf/content-testimonial": { "slug": "content/testimonial", "tags": ["#page"], "flags": {} },
  "acf/content-testimonial-callout": { "slug": "content/testimonial-callout", "tags": ["#page"], "flags": {} },
  "acf/content-text-and-flowgram": { "slug": "content/text-and-flowgram", "tags": ["#page"], "flags": {} },
  "acf/content-text-carousel": { "slug": "content/text-carousel", "tags": ["#page"], "flags": {} },
  "acf/content-text-carousel-item": { "slug": "content/text-carousel-item", "flags": {} },
  "acf/content-text-cta": { "slug": "content/text-cta", "tags": ["#page"], "flags": {} },
  "acf/content-text-media-cluster": { "slug": "content/text-media-cluster", "tags": ["#page"], "flags": {} },
  "acf/content-three-part": { "slug": "content/three-part", "tags": ["#page"], "flags": {} },
  "acf/content-three-part-item": { "slug": "content/three-part-item", "flags": {} },
  "acf/content-two-column-text": { "slug": "content/two-column-text", "tags": ["#page"], "flags": {} },
  "acf/content-two-column-text-item": { "slug": "content/two-column-text-item", "flags": {} },
  "acf/homepage-home-intro": { "slug": "homepage/home-intro", "tags": ["#page"], "flags": {} },
  "acf/parts-part-footer": { "slug": "parts/part-footer", "flags": {} },
  "acf/work-page-work-listing": { "slug": "work-page/work-listing", "tags": ["#root"], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
